import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm, FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import * as loginActions from '../../source/appstates/loginstates/loginActions';
import * as cashierActions from '../../source/appstates/cashierstates/cashierActions';
import * as appState from '../../source/appstates/appState';
import { LoginState } from '../../source/appstates/loginstates/loginState';
import { QuickregisterComponent } from '../quickregister/quickregister.component';
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';
import { PlayerService } from '../../source/services/player/player.service';
import { ethers } from "ethers";
import { LoginService } from '../../source/services/login/login.service';
import { CommondataService } from '../../source/services/games/commondata.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-quicklogin',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, TranslateModule, QuickregisterComponent, ForgotPasswordComponent],
  templateUrl: './quicklogin.component.html',
  styleUrls: ['./quicklogin.component.css']
})
export class QuickloginComponent implements OnInit, OnDestroy {
  showLoginPopup: boolean = false;
  playerLoggedIn: boolean = false;
  rememberMe: boolean = true;
  errorMessage: string = '';
  smallLoader: boolean = false;
  showPassword: boolean = false;
  contactValue: string = "";
  agentId: any;
  provider: any;

  autoGenerateEnable: boolean = false;

  googleSSO: any

  @Input() formState: string = 'LOGIN';
  @Input() providerObj: any;

  @Output() close = new EventEmitter<void>();

  FormOpenStr: string | undefined;
  storeSub!: Subscription;
  gifTimestamp = Date.now();

  @ViewChild('usernameInput') usernameInput!: ElementRef;
  @ViewChild('loginUsernameInput') loginUsernameInput!: ElementRef;
  @ViewChild('registerForm') registerForm!: NgForm;
  @ViewChild('loginForm') loginForm!: NgForm;

  register = {
    username: '',
    password: '',
    email: '',
    phone: '',
    promocode: '',
    termsAccepted: false

  };

  login = {
    username: '',
    password: ''
  };
  type: any;
  campaignCode: any = '3891faed';
  // campaignCode: any = '7314bb99';
  affcheckid: any;
  wmReferenceId: any;
  userDetails: any;
  walletAddress: string | undefined;

  otpSent = false;
  otpVerified = false;
  otpError = false;
  enteredOtp = '';
  countdown = 0;
  timer: any;

  isSendingOtp = false;
  isVerifyingOtp = false;

  MobileApibtn: boolean = false
  constructor(private store: Store<appState.AppState>, private router: Router, private playerService: PlayerService, private loginService: LoginService, 
    private comman: CommondataService,private cdr: ChangeDetectorRef) {

    const queryString = window.location.href;
    const urlParams = new URL(queryString).searchParams;
    if (window.location.search.indexOf("type=agent") != -1) {
      this.agentId = urlParams.get('ID');
      this.type = "agent";
      if (localStorage.getItem('agentCid') == null) {
        localStorage.setItem('agentCid', this.agentId)
        this.campaignCode = this.agentId;

      } else
        this.campaignCode = localStorage.getItem('agentCid')

    }
    let affiliateId = localStorage.getItem("affcheckid") || '';
    if (window.location.search.indexOf('type=affiliate') != -1) {
      this.agentId = urlParams.get('ID');
      this.affcheckid = urlParams.get('clickid')
      this.type = 'affiliate';
      if (localStorage.getItem('affCid') == null) {
        localStorage.setItem('affCid', this.agentId)
        this.campaignCode = localStorage.getItem('affCid')
      } else {
        this.campaignCode = localStorage.getItem('affCid')
      }
      if (localStorage.getItem('affcheckid') == null) {
        localStorage.setItem('affcheckid', this.affcheckid)
        this.wmReferenceId = localStorage.getItem('affcheckid') || ""
      } else {
        this.wmReferenceId = localStorage.getItem('affcheckid') || ""
      }
    } else if (affiliateId) {
      this.campaignCode = localStorage.getItem('affCid')
      this.wmReferenceId = localStorage.getItem('affcheckid')
    }


    // const urlParam = new URLSearchParams(window.location.search);
    // const sso = urlParam.get("sso");
    // this.googleSSO = sso;
  }

  ngOnInit() {
    this.FormOpenStr = this.formState || 'LOGIN';
    // this.initWeb3()
    this.openPopup();
    // if (this.formState === "WEBAUTH") {
    //   this.web3login()
    // } else {
    // }
    this.showLoginPopup = true;
    if (this.rememberMe) {
      const savedUsername = localStorage.getItem('lcUserName');
      // const savedPassword = localStorage.getItem('lcPassword');
      if (savedUsername) this.login.username = savedUsername;
      // if (savedPassword) this.login.password = savedPassword;
    }

    this.storeSub = this.store.select("loginState").subscribe(
      (loginState: LoginState) => {

        if (loginState.forgotPasswordResponse) {
          if (loginState.forgotPasswordResponse.success === true) {
            this.showLoginPopup = false;
            this.closePopup()


            this.close.emit();
          }
        }
        if (loginState.loginResponse) {
          this.comman.hideLoader();
          this.smallLoader = false;
          if (loginState.loginResponse.success === false) {
            this.errorMessage = loginState.loginResponse.description || 'Login failed';
            if (this.errorMessage === "Invalid Login or Password") {
              this.errorMessage = "Invalid Username or Password";
            } else if (this.errorMessage == "login already used") {
              this.errorMessage = "Username already used"
            } else {
              this.errorMessage = loginState.loginResponse.description || 'Login failed';

            }

            setTimeout(() => {
              this.errorMessage = '';
            }, 4000);
          }

          if (loginState.loginResponse.success === true) {
            this.playerLoggedIn = true;
            this.showLoginPopup = false;
            this.closePopup();
            this.close.emit();
          }
        }

        if (loginState.loginErrorResponse) {
          this.errorMessage = loginState.loginErrorResponse.message;
          setTimeout(() => {
            this.errorMessage = '';
          }, 5000);
        }
      }
    );

    document.addEventListener("keyup", this.handleKeyUpforEnter.bind(this));

    setTimeout(() => this.focusFirstInput(), 300);
  }




  private focusFirstInput() {
    if (this.FormOpenStr === 'LOGIN' && this.loginUsernameInput) {
      this.loginUsernameInput.nativeElement.focus();
    } else if (this.FormOpenStr === 'REGISTER' && this.usernameInput) {
      this.usernameInput.nativeElement.focus();
    }
  }

  private changeFormState(mode: 'LOGIN' | 'REGISTER' | "FORGOTPASSWORD") {
    this.FormOpenStr = 'TRANSITION';
    this.errorMessage = '';

    setTimeout(() => {
      this.FormOpenStr = mode;
      this.focusFirstInput();
    }, 150);
  }

  handleKeyUpforEnter(evt: KeyboardEvent) {
    if (evt.key === "Enter" && this.showLoginPopup) {
      this.openPopup();

      if (this.FormOpenStr === 'LOGIN') {
        this.onSubmitLogin(this.loginForm);
      } else if (this.FormOpenStr === 'REGISTER') {
        this.onSubmitRegister(this.registerForm);
      }
    }
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  onCloseLogin() {
    console.log("called");

    this.showLoginPopup = false;
    this.close.emit();
    this.closePopup()
  }

  onEnableLoginState(mode: 'LOGIN' | 'REGISTER' | 'FORGOTPASSWORD') {
    if (this.FormOpenStr !== mode) {
      this.changeFormState(mode);
      this.openPopup();
    }
  }
  openPopup() {
    console.log(123)
    document.body.classList.add('no-scroll');
  }

  closePopup() {
    document.body.classList.remove('no-scroll');
  }

  onSubmitRegister(form: NgForm) {

    if (this.registerForm.invalid) {
      return;
    }

   console.log(this.enteredOtp)
    this.gifTimestamp = Date.now();

    this.smallLoader = true;
    this.store.dispatch(new loginActions.RegisterStart(
      {
        "login": this.register.username || '',
        "nickname": this.register.username || '',
        "email": this.register.email || this.googleSSO,
        "firstName": this.register.username || '',
        "lastName": this.register.username || '',
        "password": this.register.password || this.gifTimestamp,
        "campaignCode": this.campaignCode,
        "wmReferenceId": this.wmReferenceId,
        "googleUser": false,
        "referralType": (this.type),
        "promocode": this.register.promocode,
        "address": {
          "phone": this.register.phone
        },
        "otp": this.enteredOtp
      },


    ));

    setTimeout(() => {
      this.smallLoader = false;
      this.errorMessage = '';
      // this.changeFormState('LOGIN');
      this.login.username = this.register.username;
    }, 3000);
  }

  onSubmitLogin(form: NgForm) {
    if (form.invalid) {
      return;
    }
    this.gifTimestamp = Date.now();

    this.smallLoader = true;

    if (this.rememberMe) {
      localStorage.setItem('lcUserName', this.login.username);
      // localStorage.setItem('lcPassword', this.login.password);
    } else {
      localStorage.removeItem('lcUserName');
      // localStorage.removeItem('lcPassword');
    }

    this.store.dispatch(new loginActions.LoginStart({
      login: this.login.username,
      password: this.login.password
    }));
  }

  preventSpace(event: KeyboardEvent) {
    if (event.key === ' ') {
      event.preventDefault();
    }
  }

  onCaptchaLogin() {
    this.playerService.getCaptchaLoginURL().subscribe((res: any) => {
      console.log(res);

      if (res?.URL) {
        window.location.href = res.URL;
      }
    }); 
  }

  onAutogenerate(auto: any) {
    this.playerService.getRandom(auto).subscribe((res: any) => {   
      const { login, pass } = res;
      if (login) {
        this.register.username = login;
      }
      if (pass) {
        this.register.password = pass;
      }
    })
  }

  onToggleSound(): void {
    this.autoGenerateEnable = !this.autoGenerateEnable;
    this.register.username = '';
    this.register.password = '';
    if (navigator.vibrate) {
      navigator.vibrate(50);
    }
  }

  ngOnDestroy() {
    if (this.storeSub) {
      this.storeSub.unsubscribe();
    }
    document.removeEventListener("keyup", this.handleKeyUpforEnter);
  }

  sendOtp() {
    if (!this.register.phone) {
      return;
    }

    this.isSendingOtp = true;

    let body = {
      "face": "bdtmaster",
      "ip": "",
      "language": "en",
      "mobile": this.register.phone,
      // "password": ""
    }
    this.MobileApibtn = true
    this.loginService.onRegisterGenarateOTPStart(body).subscribe(({
      next: (res: any) => {
        this.isSendingOtp = false;

        if (res.success) {
          this.otpSent = true;
          this.otpVerified = false;
          this.otpError = false;
          this.enteredOtp = '';

          this.startTimer();

        } else {
          if (res.description == "DUPLICATE_MOBILE") {
            this.errorMessage = "Mobile number already exists or invalid"

          } else if (res.description == "INVALID_INPUT_DATA") {
            this.errorMessage = "Invalid input data"
          }
          else {
            // this.errorMessage = data.description
            this.errorMessage = res.description || 'Failed to send OTP';
          }

          this.clearErrorMsg();
        }
      },

      error: () => {
        this.isSendingOtp = false;
      }
    }))

    // (res: any) => this.generateOTPRes(res))

  }

  resendOtp() {

    this.otpSent = false;
    this.enteredOtp = '';
    this.otpError = false;

    this.sendOtp();
  }


  generateOTPRes(data: any) {
    console.log(data)
    this.MobileApibtn = false
    if (data.success) {
      this.startTimer()
      this.otpSent = true
    } else {
      if (data.description == "DUPLICATE_MOBILE") {
        this.errorMessage = "Mobile number already exists or invalid"

      } else if (data.description == "INVALID_INPUT_DATA") {
        this.errorMessage = "Invalid input data"
      }
      else {
        this.errorMessage = data.description
      }
      // setTimeout(() => {
      //   this.otpfailedMessage = ''
      // }, 3000);
      // this.btndisebled = false;;

    }
    if (this.errorMessage) {
      this.clearErrorMsg()
    }

  }


  verifyOtp() {

    if (!this.enteredOtp) {
      this.errorMessage = 'Please enter valid OTP'
      return;
    }
     this.otpError = false;

    this.isVerifyingOtp = true;

    const body = {
      otp: this.enteredOtp,
      mobile: this.register.phone
    };

    this.loginService.validateOTP(body).subscribe({
      next: (res: any) => {

        this.isVerifyingOtp = false;

        if (res.success) {
          this.otpVerified = true;
          this.otpError = false;

          clearInterval(this.timer);
          this.countdown = 0;

        } else {

          this.otpVerified = false;
          this.otpError = true;
          this.enteredOtp = ''
        }
      },

      error: () => {

        this.isVerifyingOtp = false;
        this.otpError = true;
      }
    });

    //   console.log(res)
    //   if (res?.success) {
    //     this.otpVerified = true;
    //     this.otpError = false;
    //   } else {
    //     this.otpError = true;
    //     this.otpVerified = false;
    //   }
    // });

    if (this.errorMessage) {
      this.clearErrorMsg()
    }

  }



  startTimer() {
    clearInterval(this.timer);

    this.countdown = 60;


    this.timer = setInterval(() => {

      if (this.countdown > 0) {
        this.countdown--;
         this.cdr.detectChanges();
      } else {
        clearInterval(this.timer);
      }

    }, 1000);

  }

  regisphone(event: any) {
    var k;
    k = event.charCode;
    return (k == 8 || (k >= 48 && k <= 57));
  }

  clearErrorMsg() {
    setTimeout(() => {
      this.errorMessage = '';
    }, 4000);
  }
 allowNumbersOnly(event: KeyboardEvent): boolean {
  const charCode = event.which ? event.which : event.keyCode;

  if (charCode < 48 || charCode > 57) {
    event.preventDefault();
    return false;
  }

  return true;
}
}


